import WiseView from '../../WiseView.vue';
import { frontendURL } from '../../../../../helper/URLHelper';
import DashboardWise from './DashboardWise.vue';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/wise/dashboard'),
    name: 'wise',
    roles: ['administrator'],
    component: WiseView,
    children: [
      {
        path: '',
        name: 'wise_dashboard',
        component: DashboardWise,
        roles: ['administrator'],
      },
    ],
  },
];
